import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../Service/auth";
import Login from "../Components/Login";
import { notify } from "../Utils/notify";
import { auth } from './../store/auth';

export default function LoginContainer() {
  const navigate = useNavigate();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const loginRef = useRef(null);
  const passwordRef = useRef(null);

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    auth.newUser({ isAuthenticated: false, data: null, isLoading: true });
    AuthService.login({ login, password }).then(
      ({ data, status, message, error }) => {
        setIsLoading(false);
        if (error) {
          auth.newUser({ isAuthenticated: false, data: null, isLoading: false });
          notify(message, "error");
        } else {
          auth.newUser({ isAuthenticated: true, data: data, isLoading: false });
          notify(message, "success");
          navigate(`/bt/students`);
        }
      }
    );
  };

  if (!auth.user.isLoading && auth.user.isAuthenticated) {
    navigate(`/bt/students`);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === "NumpadEnter") {
      handleLogin(event);
    }
  };

  // useEffect(() => {
  //   if (user.isAuthenticated) {
  //     navigate(`/`);
  //   }
  // }, []);

  return (
    <>
      <Login
        login={login}
        password={password}
        setLogin={setLogin}
        setPassword={setPassword}
        loginRef={loginRef}
        passwordRef={passwordRef}
        handleLogin={handleLogin}
        isLoading={isLoading}
        handleKeyDown={handleKeyDown}
      />
    </>
  );
}
